// DAILY MEETING tab (HOD), same in the panel and employee sidebars.
// Competitor Analysis: only ADD here (EDIT/DELETE is in the CXO panel).
// Influencer: one link (the list page), so no sub-group.
const DAILY_MEETING = {
  title: "DAILY MEETING",
  subNav: [
    {
      title: "BATCHWISE COUNT",
      path: "cxoBatchwiseCount",
      cName: "sub-nav",
    },
    {
      title: "DATEWISE COUNT",
      path: "datewisecount",
      cName: "sub-nav",
    },
    {
      title: "LEAD ANALYSIS",
      path: "dailyLeadAnalysis",
      cName: "sub-nav",
    },
    {
      title: "REVENUE ANALYSIS",
      path: "dailyRevenueAnalysis",
      cName: "sub-nav",
    },
    {
      title: "USER ACTIVITY ANALYSIS",
      path: "userActivityAnalysis",
      cName: "sub-nav",
    },
    {
      title: "PAID ADS ANALYSIS",
      path: "dailyPaidAdsAnalysis",
      cName: "sub-nav",
    },
    {
      title: "YT STATS",
      subNav: [
        {
          title: "INSTA REELS",
          path: "instaReels",
          cName: "sub-nav",
        },
        {
          title: "LIVE YT VIDEO PERFORMANCE",
          path: "teacherPerformanceCat",
          cName: "sub-nav",
        },
        {
          title: "YT OFF TOPIC PERFORMANCE",
          path: "offTopicPerformance",
          cName: "sub-nav",
        },
      ],
    },
    {
      title: "COMPETITOR ANALYSIS",
      subNav: [
        {
          title: "LIVE VIDEO - ADD",
          path: "addLiveCompetitorAnalysis",
          cName: "sub-nav",
        },
        {
          title: "OFF TOPIC VIDEO - ADD",
          path: "addOffVideoCompetitorAnalysis",
          cName: "sub-nav",
        },
      ],
    },
    {
      title: "INFLUENCER ANALYSIS",
      path: "getInfluencer",
      cName: "sub-nav",
    },
  ],
};

export const AcademicHeadSidebarData = [
  {
    title: "LEAD DASHBOARD",
    subNav: [
      {
        title: "LEAD DASHBOARD",
        path: "leadDashboard",
        cName: "sub-nav",
      },
      {
        title: "LEAD COUNT",
        path: "LeadCount",
        cName: "sub-nav",
      },
      {
        title: "LEAD ANALYSIS",
        path: "leadAnalysis",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "TARGET STATUS",
    link: "targetStatus",
  },
  {
    title: "INFLUENCER",
    link: "getInfluencer",
  },
  {
    title: "USER DATA SEARCH",
    link: "userDataSearch",
  },

  {
    title: "TEACHER DETAILS",
    subNav: [
      {
        title: "TEACHER TASK PLAN",
        path: "teacherTaskPlan",
        cName: "sub-nav",
      },
      {
        title: "TEACHER TASK PLAN PENDING",
        path: "teacherTaskPlanPending",
        cName: "sub-nav",
      },
      {
        title: "TEACHER TASK PLAN COMPLETED",
        path: "teacherTaskPlanComplete",
        cName: "sub-nav",
      },
      {
        title: "TEACHER TASK PLAN NOT COMPLETED",
        path: "teacherTaskPlanNotComplete",
        cName: "sub-nav",
      },
      {
        title: "EDIT TEACHER TASK",
        path: "editDeleteTeacherTask",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "DOUBT SOLVE REVIEW",
    link: "doubtsolvereview",
  },
  {
    title: "ADMISSION ANALYSIS",
    subNav: [
      {
        title: "BATCHWISE COUNT",
        path: "BatchwiseCount",
        cName: "sub-nav",
      },
      {
        title: "DATEWISE COUNT",
        path: "DatewiseCount",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "REVENUE ANALYSIS",
    subNav: [
      {
        title: "REVENUE ANALYSIS",
        path: "ExamWiseRevenue",
        cName: "sub-nav",
      },
      {
        title: "PAYMENT ANALYSIS",
        path: "PaymentWiseRevenue",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "Source-Wise Analysis",
    link: "sourceWiseDataAnalysis",
  },
  {
    title: "EXAM DATA",
    link: "examDataWithoutGST",
  },
  {
    title: "ADD RESULT",
    link: "addResult",
  },
  {
    title: "STUDENT RESULT",
    link: "studentResult",
  },
  {
    title: "CRM Leads Analysis",
    subNav: [
      {
        title: "LEADS ALLOCATIONS",
        path: "teamLeadsOverview",
        cName: "sub-nav",
      },
    ],
  },
  // {
  //   title: "CATEGORY WISE ANALYSIS",
  //   link: "categoryWiseAnalysis",
  // },
  // {
  //   title: "student Details",
  //   link: "studentDetails",
  // },
  {
    title: "CATEGORY WISE ANALYSIS",
    subNav: [
      {
        title: "DAY WISE LEAD ANALYSIS",
        path: "categoryWiseAnalysis",
        cName: "sub-nav",
      },
      {
        title: "SOURCE SECTION LEAD ANALYSIS",
        path: "sourceWiseLeadAnalysis",
        cName: "sub-nav",
      },
      {
        title: "STUDENT LEAD ANALYSIS",
        path: "studentDetails",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SCHOLARSHIP EXAM RESULTS",
    link: "ScholarshipExamResult",
  },
  {
    title: "USER ACTIVITY TRACKER",
    link: "userActivityTracker",
  },
  {
    title: "Exam Analytics",
    link: "examAnalytics",
  },
  {
    title: "CRM Leads Summary",
    link: "leadSummary",
  },
  {
    title: "SUNDAY TEST ANALYSIS",
    link: "sundayTestAnalysisDashboard",
  },
  {
    title: "PAID ADS",
    link: "paidAds",
  },
  {
    title: "PAID ADS ANALYSIS",
    link: "paidAdsAnalysis",
  },
  {
    title: "Free Page Ananlysis",
    link: "freePageAnalysis",
  },
  DAILY_MEETING,
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
];

export const AcademicHeadEmpSidebarData = [
  {
    title: "LEAD DASHBOARD",
    subNav: [
      {
        title: "LEAD DASHBOARD",
        path: "leadDashboard",
        cName: "sub-nav",
      },
      {
        title: "LEAD COUNT",
        path: "LeadCount",
        cName: "sub-nav",
      },
      {
        title: "LEAD ANALYSIS",
        path: "leadAnalysis",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "TARGET STATUS",
    link: "targetStatus",
  },
  {
    title: "INFLUENCER",
    link: "getInfluencer",
  },
  {
    title: "USER DATA SEARCH",
    link: "userDataSearch",
  },

  {
    title: "TEACHER DETAILS",
    subNav: [
      {
        title: "TEACHER TASK PLAN",
        path: "teacherTaskPlan",
        cName: "sub-nav",
      },
      {
        title: "TEACHER TASK PLAN PENDING",
        path: "teacherTaskPlanPending",
        cName: "sub-nav",
      },
      {
        title: "TEACHER TASK PLAN COMPLETED",
        path: "teacherTaskPlanComplete",
        cName: "sub-nav",
      },
      {
        title: "TEACHER TASK PLAN NOT COMPLETED",
        path: "teacherTaskPlanNotComplete",
        cName: "sub-nav",
      },
      {
        title: "EDIT TEACHER TASK",
        path: "editDeleteTeacherTask",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "DOUBT SOLVE REVIEW",
    link: "doubtsolvereview",
  },
  {
    title: "ADMISSION ANALYSIS",
    subNav: [
      {
        title: "BATCHWISE COUNT",
        path: "BatchwiseCount",
        cName: "sub-nav",
      },
      {
        title: "DATEWISE COUNT",
        path: "DatewiseCount",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "REVENUE ANALYSIS",
    link: "ExamWiseRevenue",
  },
  {
    title: "Source-Wise Analysis",
    link: "sourceWiseDataAnalysis",
  },
  {
    title: "EXAM DATA",
    link: "examDataWithoutGST",
  },
  {
    title: "ADD RESULT",
    link: "addResult",
  },
  {
    title: "STUDENT RESULT",
    link: "studentResult",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "CRM Leads Analysis",
    subNav: [
      {
        title: "LEADS ALLOCATIONS",
        path: "teamLeadsOverview",
        cName: "sub-nav",
      },
    ],
  },
  // {
  //   title: "CATEGORY WISE ANALYSIS",
  //   link: "categoryWiseAnalysis",
  // },
  // {
  //   title: "student Details",
  //   link: "studentDetails",
  // },
  {
    title: "CATEGORY WISE ANALYSIS",
    subNav: [
      {
        title: "DAY WISE LEAD ANALYSIS",
        path: "categoryWiseAnalysis",
        cName: "sub-nav",
      },
      {
        title: "SOURCE SECTION WISE LEAD ANALYSIS",
        path: "sourceWiseLeadAnalysis",
        cName: "sub-nav",
      },
      {
        title: "STUDENT LEAD ANALYSIS",
        path: "studentDetails",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "SCHOLARSHIP EXAM RESULTS",
    link: "ScholarshipExamResult",
  },

  {
    title: "USER ACTIVITY TRACKER",
    link: "userActivityTracker",
  },
  {
    title: "Exam Analytics",
    link: "examAnalytics",
  },
  {
    title: "CRM Leads Summary",
    link: "leadSummary",
  },
  {
    title: "SUNDAY TEST ANALYSIS",
    link: "sundayTestAnalysisDashboard",
  },
  {
    title: "PAID ADS",
    link: "paidAds",
  },
  {
    title: "PAID ADS ANALYSIS",
    link: "paidAdsAnalysis",
  },
  {
    title: "Free Page Ananlysis",
    link: "freePageAnalysis",
  },
  DAILY_MEETING,
];
